import type { ParamMatcher } from "@sveltejs/kit";

import { DASH_URLS } from "./dash";

export const match: ParamMatcher = (param) => {
  return !DASH_URLS.includes(param);
};

// Keep in sync with is_valid_subdomain_label in
// https://github.com/modal-labs/modal-client/blob/main/modal/_utils/name_utils.py
// 63 is the DNS label limit; workspace names become hostname labels.
export const WORKSPACE_NAME_MAX_LENGTH = 63;
const WORKSPACE_NAME_PATTERN = new RegExp(
  `^(?![0-9]+$)(?!-)[a-z0-9-]{1,${WORKSPACE_NAME_MAX_LENGTH}}(?<!-)$`,
);

export const isValidWorkspaceName = (name: string): boolean => {
  return WORKSPACE_NAME_PATTERN.test(name);
};
